module.exports = __webpack_public_path__ + "static/me-556eeb816fa9e98d1321894a871d9a65.jpg";